
import React from 'react';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Store } from 'lucide-react';
import { cn } from '@/lib/utils';
import { RestaurantSelectorBaseProps } from './types';

interface RestaurantButtonSelectorProps extends RestaurantSelectorBaseProps {
  onMultiSelection: (restaurantId: string, closeAfterSelection?: boolean) => void;
}

export function RestaurantButtonSelector({
  restaurants,
  selectedRestaurants,
  onRestaurantChange,
  onMultiSelection,
  className
}: RestaurantButtonSelectorProps) {
  return (
    <div className={cn("flex flex-wrap gap-2 mt-4", className)}>
      <Button
        key="all"
        variant={selectedRestaurants.includes('all') ? "default" : "outline"}
        size="sm"
        onClick={() => onRestaurantChange(['all'])}
        className="flex items-center gap-2"
      >
        <Store className="h-4 w-4" />
        All Restaurants
      </Button>
      
      {restaurants.map(restaurant => (
        <Button
          key={restaurant.id}
          variant={selectedRestaurants.includes(restaurant.id) ? "default" : "outline"}
          size="sm"
          onClick={() => onMultiSelection(restaurant.id)}
          className="flex items-center gap-2"
        >
          {restaurant.logoUrl ? (
            <Avatar className="h-5 w-5">
              <AvatarImage src={restaurant.logoUrl} alt={restaurant.name} />
              <AvatarFallback className="text-xs">
                {restaurant.name.substring(0, 2).toUpperCase()}
              </AvatarFallback>
            </Avatar>
          ) : (
            <Store className="h-4 w-4" />
          )}
          {restaurant.name}
        </Button>
      ))}
    </div>
  );
}
